import { Listing, Service } from "../types";

function serialisePhoneNumber(service: Service) {
  const contacts = service.contacts;

  const phoneType = contacts.find(
    (contact) => contact?.valueType?.label === "Phone",
  );

  return phoneType && phoneType.value;
}

function serialiseWebsite(service: Service) {
  const contacts = service.contacts;

  const websiteType = contacts.find(
    (contact) => contact?.valueType?.label === "Website",
  );

  return websiteType && websiteType.value;
}

function serialiseAddress(service: Service) {
  const location = service.location?.physicalLocation;

  if (!location) {
    return;
  }

  const titleizeSuburb = `${location.suburb.label.charAt(
    0,
  )}${location.suburb.label.slice(1).toLowerCase()}`;

  return (
    location && {
      addressLine1: location.addressLine1,
      addressLine2: location.addressLine2,
      addressLine3: location.addressLine3,
      suburb: titleizeSuburb,
      postcode: location.postcode,
      state: location.state.label,
      lat: location.geocode.latitude,
      lng: location.geocode.longitude,
    }
  );
}

function serialiseBulkBills(service: Service) {
  if (!service.billingOptions || service.billingOptions.length === 0) {
    return null;
  }

  return service.billingOptions.some((billingOption) => {
    return (
      billingOption.valueType.idRef ===
      "nhsd:/reference/common/feeAndBillingOption/feesAndBulkBilling"
    );
  });
}

function serialiseCalendar(service: Service) {
  const calendar = service.calendar;

  if (!calendar) {
    return null;
  }

  return calendar;
}

function serialiseService(service: Service): Listing {
  return {
    id: service.id,
    displayName:
      service.displayName ||
      service.location?.name ||
      service.organisation?.name,
    phoneNumber: serialisePhoneNumber(service),
    website: serialiseWebsite(service),
    address: serialiseAddress(service),
    bulkBills: serialiseBulkBills(service),
    calendar: serialiseCalendar(service),
  };
}
export default serialiseService;
